
let menu = [
    {
        name: 'Home',
        url: '/'
    }
];

export default menu;